import { FormattedNumber } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { EdgeBalance } from '@/components/edge-balance'
import { edgeCountToOneBucks } from '@/pages/rewards/constants'

export const CryptoRedeemSum = ({ edge }: { edge: number }) => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <div className="flex items-center justify-center gap-1">
      <EdgeBalance
        balance={edge}
        iconSize={isSmAndLower ? 32 : 48}
        typoProps={{
          variant: isSmAndLower ? 'h5' : 'h3',
        }}
      />{' '}
      <Typography
        color="text.secondary"
        variant="h3"
      >
        =
      </Typography>
      <Typography
        color="text.secondary"
        variant={isSmAndLower ? 'h5' : 'h3'}
      >
        <FormattedNumber
          currency="USD"
          style="currency"
          value={edge / edgeCountToOneBucks}
        />
      </Typography>
    </div>
  )
}
